module.exports = __webpack_public_path__ + "static/presidents-message-5eb34f257c9c97f0c30a39167aec1c0e.jpg";